/**
 * Created by RaoMeng on 2020/10/30
 * Desc: 拜访记录item
 */

import React, { Component } from 'react'
import '../style/css/visit-record.css'

export default class VisitRecordItem extends Component {

  constructor () {
    super()

    this.state = {}
  }

  componentDidMount () {
  }

  componentWillUnmount () {

  }

  render () {
    const { visitRecord } = this.props
    return (
      <div className='visit-record-item-root'>
        <div className='visit-record-item-bg' onClick={this.onRecordClick}>
          <div className="visit-record-item-line">
            <div className='visit-record-item-caption'>被拜访人：</div>
            <div
              className='visit-record-item-value'
              style={{ flex: 1 }}>{visitRecord.objectName}</div>
            <div className={visitRecord.visitStatus == 1
              ? 'visit-record-item-status-yes'
              : 'visit-record-item-status-no'}>{visitRecord.visitStatus == 1
              ? '已拜访'
              : (visitRecord.visitStatus == 2 ? '已过期' : '未拜访')}</div>
          </div>

          <div className="visit-record-item-line">
            <div className='visit-record-item-caption'>计划拜访日期：</div>
            <div
              className='visit-record-item-value'>{visitRecord.visitTime}</div>
          </div>
        </div>
      </div>
    )
  }

  onRecordClick = () => {
    this.props.onRecordClick && this.props.onRecordClick(this.props.visitRecord)
  }
}
